import React, { useState, useEffect } from "react";
import HeroSection from "../components/common/HeroSection";
import ProjectsSection from "../components/common/ProjectsSection";
import ExperienceSection from "../components/common/ExperienceSection";
import ContactComponent from "../components/ContactComponent";

const Portfolio = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div
      className={`min-h-fit px-2 transition-filter duration-1000 ${
        isLoaded ? "filter-none" : "blur-sm"
      }`}
    >
      <div className="flex flex-col w-full min-h-screen relative">
        <div className="mt-36 md:mt-48">
          <HeroSection />
          <ExperienceSection />
          <ProjectsSection />
          <ContactComponent />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
